export interface PlanUpdateRequestModel {
  planId: string;
}
